// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.text-line-height[data-v-7f94cf24] {\n    line-height: 1.4rem;\n}\n.promotion-gradient[data-v-7f94cf24] {\n    background-image: linear-gradient(rgba(0, 0, 0, 70%), rgba(0, 0, 0, 100%));\n    min-height: 80px;\n    height: 80px;\n    position: absolute !important;\n    bottom: 0;\n}\n.rounded-b-0[data-v-7f94cf24] {\n    border-top-right-radius: 5px !important;\n    border-top-left-radius: 5px !important;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
